// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../fonts/Inter-Regular400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../fonts/Inter-Medium500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../fonts/Inter-SemiBold600.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../fonts/Inter-Bold700.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 400;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 500;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "Inter";
  font-display: swap;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
  font-weight: 700;
  font-style: normal;
}
.Input_icon__HtCC0 {
  position: absolute;
  left: 13px;
  top: 10px;
  height: 18px;
  z-index: 6;
}
.Input_icon__HtCC0 svg {
  height: 18px;
}

.Input_wrapper__0GTG\\+ {
  position: relative;
}

.Input_eye__IPoqy {
  position: absolute;
  right: 10px;
  top: 15px;
  z-index: 2;
  cursor: pointer;
}
.Input_eye__IPoqy .svg-inline--fa.fa-eye.fa-1x {
  color: #31C9CA !important;
}
.Input_eye__IPoqy .svg-inline--fa.fa-eye-slash.fa-1x {
  color: #a9a9a9 !important;
}

.Input_input__xC1Gr {
  border-radius: 12px !important;
  width: 100% !important;
  height: 44px;
  padding: 14px 17px 14px 42px !important;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  transition: 0.3ms;
  box-sizing: border-box;
}
.Input_input_container__TcXfQ {
  position: relative;
}
.Input_input_default__DYW-1 {
  background-color: #F3F3F4 !important;
  border: none !important;
  color: #758282 !important;
  -webkit-box-shadow: inset 0 0 0 50px #F3F3F4;
  -webkit-text-fill-color: #758282;
}
.Input_input_default__DYW-1:hover {
  background-color: #F3FFFF !important;
  border: 1px solid #31C9CA !important;
  color: #616E6E !important;
  -webkit-box-shadow: inset 0 0 0 50px #F3FFFF !important;
  -webkit-text-fill-color: #616E6E;
}
.Input_input_active__Dzzbl {
  border: 1px solid #ffa368 !important;
  -webkit-text-fill-color: #000 !important;
  background-color: #FFF !important;
  -webkit-box-shadow: inset 0 0 0 50px #ffffff;
}
.Input_input_error__VpDQr {
  border: 1px solid #FF5756 !important;
  -webkit-text-fill-color: #000 !important;
  background-color: #FFF !important;
  -webkit-box-shadow: inset 0 0 0 50px #ffffff;
  margin-bottom: 0 !important;
}
.Input_input_valid__G\\+eUj {
  border: 1px solid #1DB5B6 !important;
  -webkit-text-fill-color: #000 !important;
  background-color: #FFF !important;
  -webkit-box-shadow: inset 0 0 0 50px #ffffff !important;
}

.Input_input_container__TcXfQ label {
  transition: 0.5s;
  transform: translate(42px, -28px);
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  position: absolute;
}

.Input_input_container__TcXfQ input:focus + label, .Input_input_container__TcXfQ .Input_input_valid__G\\+eUj + label, .Input_input_container__TcXfQ .Input_input_error__VpDQr + label {
  font-size: 13px;
  transform: translate(32px, -50px);
  background: #fff !important;
  padding: 0 3px;
}

.Input_input_container__TcXfQ input:-webkit-autofill + label {
  font-size: 13px;
  transform: translate(32px, -50px);
  background: #ffffff91;
  padding: 0 3px;
}`, "",{"version":3,"sources":["webpack://./src/styles/vendors/fonts.scss","webpack://./src/components/UI/Input/Input.module.scss","webpack://./src/styles/icon.scss","webpack://./src/styles/vendors/mixins.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACCF;ADEA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACAF;ADGA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACDF;ADIA;EACE,oBAAA;EACA,kBAAA;EACA,4DAAA;EACA,gBAAA;EACA,kBAAA;ACFF;AC3BA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AD6BF;AC3BE;EACE,YAAA;AD6BJ;;AAjCA;EACE,kBAAA;AAoCF;;AAjCA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAoCF;AAlCE;EACE,yBAAA;AAoCJ;AAjCE;EACE,yBAAA;AAmCJ;;AA/BA;EEvBE,8BAAA;EACA,sBAAA;EACA,YAAA;EACA,uCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;AF0DF;AA1CE;EACE,kBAAA;AA4CJ;AAzCE;EEhBA,oCAAA;EACA,uBAAA;EACA,yBAAA;EACA,4CAAA;EACA,gCAAA;AF4DF;AA7CI;EEXF,oCAAA;EACA,oCAAA;EACA,yBAAA;EACA,uDAAA;EACA,gCAAA;AF2DF;AA/CE;EERA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,4CAAA;AF0DF;AAjDE;EELA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,4CAAA;EACA,2BAAA;AFyDF;AApDE;EEDA,oCAAA;EACA,wCAAA;EACA,iCAAA;EACA,uDAAA;AFwDF;;AArDA;EACE,gBAAA;EACA,iCAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAwDF;;AArDA;EACE,eAAA;EACA,iCAAA;EACA,2BAAA;EACA,cAAA;AAwDF;;AArDA;EACE,eAAA;EACA,iCAAA;EACA,qBAAA;EACA,cAAA;AAwDF","sourcesContent":["@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Regular400.woff2\") format(\"woff2\");\n  font-weight: 400;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Medium500.woff2\") format(\"woff2\");\n  font-weight: 500;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-SemiBold600.woff2\") format(\"woff2\");\n  font-weight: 600;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Inter\";\n  font-display: swap;\n  src: url(\"../../fonts/Inter-Bold700.woff2\") format(\"woff2\");\n  font-weight: 700;\n  font-style: normal;\n}","@import \"../../../styles/vendors/mixins\";\n@import \"../../../styles/vendors/fonts\";\n@import \"../../../styles/icon\";\n\n.wrapper {\n  position: relative;\n}\n\n.eye {\n  position: absolute;\n  right: 10px;\n  top: 15px;\n  z-index: 2;\n  cursor: pointer;\n\n  :global(.svg-inline--fa.fa-eye.fa-1x ) {\n    color: #31C9CA !important;\n  }\n\n  :global(.svg-inline--fa.fa-eye-slash.fa-1x ) {\n    color: #a9a9a9 !important;\n  }\n}\n\n.input {\n  @include input;\n\n  &_container {\n    position: relative;\n  }\n\n  &_default {\n    @include input_default;\n\n    &:hover {\n      @include input_hover;\n    }\n  }\n\n  &_active {\n    @include input_active;\n  }\n\n  &_error {\n    @include input_error;\n  }\n\n  &_valid {\n    @include input_valid;\n  }\n}\n\n.input_container label {\n  transition: 0.5s;\n  transform: translate(42px, -28px);\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  position: absolute;\n}\n\n.input_container input:focus + label, .input_container .input_valid + label, .input_container .input_error + label {\n  font-size: 13px;\n  transform: translate(32px, -50px);\n  background: #fff !important;\n  padding: 0 3px;\n}\n\n.input_container input:-webkit-autofill + label {\n  font-size: 13px;\n  transform: translate(32px, -50px);\n  background: #ffffff91;\n  padding: 0 3px;\n}",".icon {\n  position: absolute;\n  left: 13px;\n  top: 10px;\n  height: 18px;\n  z-index: 6;\n\n  svg {\n    height: 18px;\n  }\n}","@mixin input {\n  border-radius: 12px !important;\n  width: 100% !important;\n  height: 44px;\n  padding: 14px 17px 14px 42px !important;\n  font-family: 'Inter', sans-serif;\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 14px;\n  transition: 0.3ms;\n  box-sizing: border-box;\n}\n\n@mixin input_default {\n  background-color: #F3F3F4 !important;\n  border: none !important;\n  color: #758282 !important;\n  -webkit-box-shadow: inset 0 0 0 50px #F3F3F4;\n  -webkit-text-fill-color: #758282;\n}\n\n@mixin input_hover {\n  background-color: #F3FFFF !important;\n  border: 1px solid #31C9CA !important;\n  color: #616E6E !important;\n  -webkit-box-shadow: inset 0 0 0 50px #F3FFFF !important;\n  -webkit-text-fill-color: #616E6E;\n}\n\n@mixin input_active {\n  border: 1px solid #ffa368 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff;\n}\n\n@mixin input_error {\n  border: 1px solid #FF5756 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff;\n  margin-bottom: 0 !important;\n}\n\n@mixin input_valid {\n  border: 1px solid #1DB5B6 !important;\n  -webkit-text-fill-color: #000 !important;\n  background-color: #FFF !important;\n  -webkit-box-shadow: inset 0 0 0 50px #ffffff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `Input_icon__HtCC0`,
	"wrapper": `Input_wrapper__0GTG+`,
	"eye": `Input_eye__IPoqy`,
	"input": `Input_input__xC1Gr`,
	"input_container": `Input_input_container__TcXfQ`,
	"input_default": `Input_input_default__DYW-1`,
	"input_active": `Input_input_active__Dzzbl`,
	"input_error": `Input_input_error__VpDQr`,
	"input_valid": `Input_input_valid__G+eUj`
};
export default ___CSS_LOADER_EXPORT___;
